// profile-application.service.ts
import { Injectable } from '@angular/core';

import { ApiResponse } from '../../models/profile.model'; // the types from previous answer

import { ApiService } from '../core/api.service';
import { AuthService , User } from '../auth/auth.service';


type ProfileMeResponse = {
  user: User;
};

@Injectable({ providedIn: 'root' })
export class ProfileService {
  

  constructor(
    private api: ApiService,
    private auth: AuthService,
  ) {}

  getProfileDefinition(): Promise<ApiResponse> {
    const endpoint = 'profile';
    return this.api.get<ApiResponse>(endpoint);
  }

  saveProfile(payload: any): Promise<any> {
    // Use PUT vs POST depending on your API contract
    const endpoint = 'profile';
    return this.api.post<ApiResponse>(endpoint, payload);
    
  }

  patchProfile(payload: any): Promise<any> {
    // Use PUT vs POST depending on your API contract
    const endpoint = 'profile';
    return this.api.patch<ApiResponse>(endpoint, payload);
    
  }

  getApplicationDefinition(): Promise<ApiResponse> {
    const endpoint = 'profile/application';
    return this.api.get<ApiResponse>(endpoint);
  }

  saveApplication(payload: any): Promise<any> {
    // Use PUT vs POST depending on your API contract
    const endpoint = 'profile/application';
    return this.api.post<ApiResponse>(endpoint, payload);
    
  }

  uploadPhoto(file: File): Promise<any> {
    const formData = new FormData();
    formData.append('photo', file);

    const endpoint = 'profile/avatar';
    var response = this.api.post<ApiResponse>(endpoint, formData);
    this.refreshUser();
    return response;
    /*return firstValueFrom(
      this.http.post<{ message: string; photo_url: string }>(
        `${this.baseUrl}/photo`,
        formData
      )
    );
    */
  }

  async refreshUser(): Promise<User> {
    const res = await this.api.get<ProfileMeResponse>('profile/me');
    // console.log('profile/me response', res);

    const user = res.user;          // 👈 grab the inner user
    await this.auth.updateUser(user);
    return user;
  }

  /*refreshUser(): Promise<any> {
    const endpoint = 'profile/me';
    var response = this.api.get<ApiResponse>(endpoint);
    // console.log(response);
    return response;
  }
  */



  // if you later need to POST:
  // save(payload: any): Promise<any> { ... }
}